// app/components/form-sections/UniversalHeaderSection.jsx
"use client";
import { useState } from "react";
import Field from "../ui/Field";
import { HistoryDatalist } from "../ui/HistoryDatalist";
import SchoolLogoUploader from "../SchoolLogoUploader";

export default function UniversalHeaderSection({ form, setField, pushHistory, history, todayLong }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-2xl border border-gray-200 bg-white mt-6">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-3 sm:px-5 border-b border-gray-200 hover:bg-slate-100"
        aria-expanded={open}
        aria-controls="universal-header-panel"
      >
        <span className="text-[13px] sm:text-sm font-semibold text-slate-900">Universal Header</span>
        <span className="inline-flex items-center gap-2 text-sm text-gray-700">
          {open ? "Hide" : "Show"}
          <svg className={`h-5 w-5 transition-transform ${open ? "rotate-180" : ""}`} viewBox="0 0 20 20" fill="currentColor" aria-hidden>
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08z" clipRule="evenodd" />
          </svg>
        </span>
      </button>

      {open && (
        <div id="universal-header-panel" className="p-4 sm:p-5 grid gap-4">
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Program / Department line">
              <input
                placeholder="Esteemed Residency Program"
                className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
                value={form.header_line1}
                onChange={setField("header_line1")}
                onBlur={(e) => pushHistory("header_line1", e.target.value)}
                list="hist-header_line1"
              />
              <HistoryDatalist id="hist-header_line1" values={history["header_line1"] || []} />
            </Field>

            <Field label="University / Organization">
              <input
                placeholder="Well-Known University"
                className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
                value={form.header_line2}
                onChange={setField("header_line2")}
                onBlur={(e) => pushHistory("header_line2", e.target.value)}
                list="hist-header_line2"
              />
              <HistoryDatalist id="hist-header_line2" values={history["header_line2"] || []} />
            </Field>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Address line 1">
              <input
                placeholder="1234 University Way"
                className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
                value={form.header_addr1}
                onChange={setField("header_addr1")}
                onBlur={(e) => pushHistory("header_addr1", e.target.value)}
                list="hist-header_addr1"
              />
              <HistoryDatalist id="hist-header_addr1" values={history["header_addr1"] || []} />
            </Field>

            <Field label="Address line 2">
              <input
                placeholder="Big City, Florida 54321"
                className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
                value={form.header_addr2}
                onChange={setField("header_addr2")}
                onBlur={(e) => pushHistory("header_addr2", e.target.value)}
                list="hist-header_addr2"
              />
              <HistoryDatalist id="hist-header_addr2" values={history["header_addr2"] || []} />
            </Field>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Date">
              <div className="flex gap-2">
                <input
                  placeholder={todayLong}
                  className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
                  value={form.date}
                  onChange={setField("date")}
                  onBlur={(e) => pushHistory("date", e.target.value)}
                  list="hist-date"
                />
                <button
                  type="button"
                  onClick={() => setField("date")({ target: { value: todayLong } })}
                  className="rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm font-medium hover:bg-slate-100"
                >
                  Today
                </button>
              </div>
              <HistoryDatalist id="hist-date" values={history["date"]} />
            </Field>

            <Field label='Greeting role (used in "Dear …,")'>
              <input
                placeholder="Program Director"
                className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
                value={form.header_greeting}
                onChange={setField("header_greeting")}
                onBlur={(e) => pushHistory("header_greeting", e.target.value)}
                list="hist-header_greeting"
              />
              <HistoryDatalist id="hist-header_greeting" values={history["header_greeting"] || []} />
            </Field>
          </div>

          <Field label="School Logo (optional)">
            <SchoolLogoUploader
              value={form.header_logoDataUrl}
              onChange={(dataUrl) => setField("header_logoDataUrl")({ target: { value: dataUrl } })}
              align={form.header_logoAlign}
              onAlignChange={(pos) => setField("header_logoAlign")({ target: { value: pos } })}
              width={form.header_logoWidth}
              onWidthChange={(w) => setField("header_logoWidth")({ target: { value: w } })}
            />
          </Field>
        </div>
      )}
    </div>
  );
}
